module.exports = __webpack_public_path__ + "img/cover-popular-bg.5a38539b.jpg";